import { render } from "./AdminPane.vue?vue&type=template&id=4ae55322&scoped=true"
import script from "./AdminPane.vue?vue&type=script&lang=js"
export * from "./AdminPane.vue?vue&type=script&lang=js"

import "./AdminPane.vue?vue&type=style&index=0&id=4ae55322&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae55322"]])

export default __exports__